import './App.css';
import MapContainer from './components/MapContainer/MapContainer';
import BtnOnMapGroup from './components/BtnOnMapGroup/BtnOnMapGroup';
import Sidebar from './components/Sidebar/Sidebar';
import { MapDisplayProvider } from './contexts/MapDisplayContext';
import { VesselProvider } from './contexts/VesselContext';
import { ChatProvider } from './contexts/ChatContext';
import { WarningZoneProvider } from './contexts/WarningZoneContext';
import { AppProvider } from './contexts/AppContext';
import AppInitializer from './AppInitializer';
import { SidebarProvider } from './contexts/SidebarContext';

function App() {
  return (
    <>
      <VesselProvider>
        <ChatProvider>
          <WarningZoneProvider>
            <SidebarProvider>
              <MapDisplayProvider>
                <AppProvider>
                  <AppInitializer />
                  <BtnOnMapGroup />
                  <Sidebar />
                  <MapContainer />
                </AppProvider>
              </MapDisplayProvider>
            </SidebarProvider>
          </WarningZoneProvider>
        </ChatProvider>
      </VesselProvider>
    </>
  );
}

export default App;
